import { render, staticRenderFns } from "./index.vue?vue&type=template&id=ff310f5c&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=ff310f5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff310f5c",
  null
  
)

export default component.exports